//
import { Link } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./style.css";
import ShimmerUI from "components/allProducts/shimmer/ShimmerUI";
import BreadCrumbs from "components/breadcrumb/BreadCrubs";
import { useState, useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
//
import { useDispatch, useSelector } from "react-redux";
//
import { fetchReviews } from "./data";

//
const Review = () => {
  //
  //
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(4);

  const { items } = useSelector((state) => state.newProductReducer);

  useEffect(() => {
    fetchReviews().then((data) => {
      setReviews(data);
      setLoading(false);
    });
  }, []);

  const loadMore = () => setVisibleCount((prev) => prev + 2);

  return (
    <div className="min-h-screen mb-56">
      <div className="container ">
        <BreadCrumbs />
        <h1 className="" id="allposts">
          Agrotrac Digital Reviews
        </h1>
      </div>
      <div className="container flex items-center justify-center my-6 md:my-4">
        <img src="images/business-strategy-leaderboard-ad.jpg" alt="" />
      </div>
      <div className="container grid grid-cols-1 md:grid-cols-4  relative">
        <div className="col-span-3">
          <div className="">
            {loading ? (
              <div className="flex flex-col p-2">
                {[1, 2, 3, 4].map((item, index) => (
                  <Box sx={{ pt: 0.5 }} key={index}>
                    <Skeleton variant="rectangular" height={118} />
                    <Skeleton />
                    <Skeleton />
                  </Box>
                ))}
              </div>
            ) : (
              reviews.slice(0, visibleCount).map((item, number) => {
                return (
                  <Link to={`#`} className="relative" key={number}>
                    <div className="md:h-70 w-full border border-slate-100 relative mb-2">
                      <div class="flex flex-col md:flex-row w-full ">
                        <div className="md:h-60 md:w-80 bg-slate-200">
                          <img
                            src={item?.image}
                            className=" w-full h-full object-contain p-1"
                            alt="agrotracdigital reviews image"
                          />
                        </div>
                        {/* //
                    // */}
                        <div className="grow flex flex-col justify-between md:ml-3 w-full md:h-60 p-2 bg-white">
                          <h1 className="text-[28px]">{item?.title}</h1>
                          <p
                            className="text-[14px]  overflow-y-hidden text-ellipsis"
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          ></p>

                          <div className="flex justify-between mt-2">
                            <p className="text-[12px] font-medium">
                              <AccountCircleIcon /> {item.reviewer || "admin"}
                            </p>
                            <p className="text-[12px] font-medium sm:hidden md:block">
                              {item?.date || "01/05/2025"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
          </div>

          {visibleCount < reviews?.length && (
            <div className="flex justify-center">
              <button
                onClick={loadMore}
                className="border-2 border-[#1550A1] mt-2 text-[14px] font-roboto text-[#1550A1] px-12 py-2 font-medium"
              >
                Load More Reviews
              </button>
            </div>
          )}
        </div>

        <div className=" mt-12 md:mt-0 mb-24 md:mb-0 sticky px-2 bg-white">
          <h2 className="bg-[#1550A1] text-white px-2  md:mt-2">
            Related Products
          </h2>
          <ul className="mt-2">
            {reviews
              ? items?.map((item, number) => {
                  return (
                    <Link
                      to={`/new-implements/${item.id}/${item.product_name}`}
                      className="text-xs underline block my-3 text-blue-800 text-justify"
                    >
                      {item.product_name}
                    </Link>
                  );
                })
              : [1].map((item, index) => <ShimmerUI key={index} />)}
          </ul>
          <div className="advertisement pt-2 md:pt-10">
            <Link to={"/new-implements/2/FARMPOWER%20ROTAVATOR%20XXTRA%20DUM/"}>
              <img
                src="images/441927465_972805741300417_7932176696816619435_n.jpg"
                alt=""
                className="rounded-md"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
